import React from 'react';
import './MultiSignalsBackButton.scss';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ArrowLeft, ChevronLeft } from 'lucide-react';

function MultiSignalsBackButton({ ...props }) {
  const { buttonText = 'Back', variant = 'default' } = props;
  const history = useHistory();

  function backToList() {
    history.goBack();
  }

  return (
    <button
      type="button"
      className={`modern-back-button ${variant}`}
      onClick={backToList}
    >
      <div className="button-content">
        <div className="icon-container">
          {variant === 'minimal' ? (
            <ChevronLeft size={20} className="back-icon" />
          ) : (
            <ArrowLeft size={18} className="back-icon" />
          )}
        </div>
        <span className="button-text">
          {buttonText}
        </span>
      </div>
      <div className="hover-effect"></div>
    </button>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiSignalsBackButton);